module.exports = __webpack_public_path__ + "img/platform-icon.31519db5.gif";